<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :model="formData"
        :rules="rules"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="9">
            <el-form-item
              label="是否启用到货登记："
              prop="openPoint"
            >
              <el-radio-group
                v-model="formData.openPoint"
                :disabled="isDetail"
                @change="handleOpenPointChange"
              >
                <el-radio
                  v-for="item in BOOLEAN_STATE"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="2"
          :form-data="formData"
          :table-data="formData.taskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import TaskSetting from './TaskSetting.vue';
import { BOOLEAN_STATE, NODE_TYPE } from './constant';

export default {
  components: {
    ListBlock,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BOOLEAN_STATE,
      rules: {
        openPoint: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    handleOpenPointChange(val) {
      this.$refs.taskTableEl.disableTask(val);
    },
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    // 重置任务下拉数据
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(2);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[2].label}”节点数据`);
        }
      });
    },
  },
};
</script>
